import axios from 'axios';
import { EventBus } from '../event/event-bus.js';
import router from '.././router';

const apiUrl = `${window.location.origin}/api`;

const client = axios.create({
    baseURL: apiUrl,
    json: true
})

export default {
    async execute(method, resource, data, accessToken) {
        return await client({
            method,
            url: resource,
            data,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        }).then(req => {
            if (method === "post" || method === "put" || method === "delete") {
                EventBus.$emit('emit-success');
            }
            return req.data
        }).catch((error) => {
            if (error.response) {
                if (error.response.status === 403) {
                    router.push({ name: 'Unauthorized' });
                    return;
                } else if (error.response.status === 401) {
                    location.reload();
                    return;
                }
            }
            EventBus.$emit('emit-error', error.response.data);
        })
    },
    //Operators
    async searchOperators(accessToken, searchText, pageNo, pageSize, orderBy, sorting) {
        return await this.execute('get', `/operator/search?pageNo=${pageNo}&pageSize=${pageSize}&searchText=${searchText}&orderBy=${orderBy}&sorting=${sorting}`, null, accessToken);
    },
    async getUserOperatorBrands(accessToken) {
        return await this.execute('get', `/operator/user/brands`, null, accessToken);
    },
    async searchOperatorSensitiveNames(accessToken, operatorId, searchText, pageNo, pageSize, orderBy, sorting) {
        return await this.execute('get', `/operator/${operatorId}/sensitivename/search?pageNo=${pageNo}&pageSize=${pageSize}&searchText=${searchText}&orderBy=${orderBy}&sorting=${sorting}`, null, accessToken);
    },
    async createOperatorSensitiveName(accessToken, operatorId, request) {
        return await this.execute('post', `/operator/${operatorId}/sensitivename`, request, accessToken);
    },
    async deleteOperatorSensitiveName(accessToken, operatorId, sensitiveNameId) {
        return await this.execute('delete', `/operator/${operatorId}/sensitivename/${sensitiveNameId}`, null, accessToken);
    },
    async getOperatorById(id, accessToken) {
        return await this.execute('get', `/operator/${id}`, null, accessToken);
    },
    async updateOperator(request, accessToken) {
        return await this.execute('put', `/operator`, request, accessToken);
    },
    async createOperator(request, accessToken) {
        return await this.execute('post', `/operator`, request, accessToken);
    },
    async createOperatorBrand(id, request, accessToken) {
        return await this.execute('post', `/operator/${id}/brand`, request, accessToken);
    },
    async deleteOperatorBrandById(id, operatorBrandId, accessToken) {
        return await this.execute('delete', `/operator/${id}/brand/${operatorBrandId}`, null, accessToken);
    },
    async addOperatorMenu(id, request, accessToken) {
        return await this.execute('post', `/operator/${id}/menu`, request, accessToken);
    },
    async deleteOperatorMenuById(id, operatorMenuId, accessToken) {
        return await this.execute('delete', `/operator/${id}/menu/${operatorMenuId}`, null, accessToken);
    }
}
